import DatePickerInput from "components/datePickerInput/DatePickerInput";
import { useAppSelector } from "hooks/redux";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CourseStatus from "./dashboardWidgets/courseStatus/CourseStatus";
import "./dashboardNew.scss";
import useDashboard from "./useDashboard";
import BookingType from "./dashboardWidgets/bookingType/BookingType";
import Events from "./dashboardWidgets/eventsWidget/Events";
import PlayerVolume from "./dashboardWidgets/playerVolume/PlayerVolume";

export default function DashboardNew() {
  const { authStore } = useAppSelector(store => store);
  const { t } = useTranslation();
  const [date, setDate] = useState(new Date());
  const { statuses, bookingsByCategory, events, teetimes, bookingCategories } = useDashboard({ date: date });

  return (
    <div className="ui-dashboard">
      <div className="ui-dashboard-header">
        <p className="ui-dashboard-title">
          {t("Welcome Back")}, {authStore?.user?.full_name}!
        </p>
        <DatePickerInput
          months={1}
          position="right"
          startingDate={date}
          setStartingDate={(date: Date) => setDate(date)}
        />
      </div>
      <div className="ui-dashboard-body">
        <div className="ui-dashboard-row">
          <CourseStatus statuses={statuses} date={date} />
          <BookingType bookingTypesCounts={bookingsByCategory} bookingCategories={bookingCategories} />
          <Events events={events} date={date} />
        </div>
        <div className="ui-dashboard-row">
          <PlayerVolume teetimes={teetimes} />
        </div>
      </div>
    </div>
  );
}
